export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Index.vue?vue&type=template&id=b5285800&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Styles/Index.vue?vue&type=template&id=b5285800&scoped=true&
// module id = null
// module chunks = 